import { Container } from "react-bootstrap";

import { useTranslation } from 'react-i18next';
import useHorizontalCarousel from "./useHorizontalCarousel";
import limpiarHtml from "./limpiarHtml";

const ListaCaracteristicas = ({ caracteristicas, config }) => {

    const { t } = useTranslation();

    return (
        <>
            <div className="row text-center">
                <div className="col-md-8 offset-md-2 bhh-section__head">
                    <span className="bhh-eyebrow">{t("Servicios")}</span>
                    <h2>{config.nombre_comercial}</h2>
                    <p className="font-italic mb-5">{t("¿Por_qué_reservar_con_nosotros?")}</p>
                </div>
            </div>
            <div className="row gx-lg-5">
                {caracteristicas.map((caracteristica, index) => (
                    <div className="col-lg-6 col-xxl-4 mb-5" id={index} key={index}>
                        <div className="card bg-light border-0 h-100 shadow br15 bg-white">
                            <div className="card-body text-center p-4 p-lg-5 pt-0 pt-lg-0">
                                <div className="caracteristica mb-5">
                                    <i className={"fa-duotone " + caracteristica['imagen'] + " fa-2x"}></i>
                                </div>
                                <h3 className="fs-4 fw-bold">{caracteristica['elnombre']}</h3>
                                {/* div, no <p>: el text de l'admin ja porta els
                                    seus propis <p> — dins un <p> de React quedaven
                                    niats (HTML invàlid) i el navegador els partia
                                    sol en <p> germans amb el seu marge per defecte,
                                    afegint salts extra entre línies. */}
                                <div className="mb-0 caracteristica-desc" dangerouslySetInnerHTML={{ __html: limpiarHtml(caracteristica['ladesc']) }}></div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}

{/* Carrusel horitzontal, mateix patró que Destacados: fila amb scroll natiu
    + fletxes que fan scrollBy(). S'activa amb variant="carousel" — l'usen
    Inicio i SobreNosotros; qualsevol altra pàgina que no el passi es queda
    amb la graella bootstrap de sempre. */}
const CarouselCaracteristicas = ({ caracteristicas, config }) => {

    const { t } = useTranslation();

    const { trackRef, navState, scrollByCard } = useHorizontalCarousel('.bhh-caracteristicas__item', caracteristicas.length);

    return (
        <div className="bhh-caracteristicas__layout">
            <div className="bhh-caracteristicas__intro">
                <span className="bhh-eyebrow">{t("Servicios")}</span>
                <h2>{config.nombre_comercial}</h2>
                <p className="font-italic mb-0">{t("¿Por_qué_reservar_con_nosotros?")}</p>
                <div className="bhh-caracteristicas__nav">
                    <button
                        type="button"
                        disabled={navState.atStart}
                        onClick={() => scrollByCard(-1)}
                        className="bhh-destacados__prev"
                        aria-label={t("Anterior")}
                    >
                        <i className="fa-solid fa-arrow-left"></i>
                    </button>
                    <button
                        type="button"
                        disabled={navState.atEnd}
                        onClick={() => scrollByCard(1)}
                        className="bhh-destacados__next"
                        aria-label={t("Siguiente")}
                    >
                        <i className="fa-solid fa-arrow-right"></i>
                    </button>
                </div>
            </div>

            <div className="bhh-caracteristicas__track" ref={trackRef}>
                {caracteristicas.map((caracteristica, index) => (
                    <div className="bhh-caracteristicas__item" key={index}>
                        <span className="bhh-caracteristicas__icon">
                            <i className={"fa-duotone " + caracteristica['imagen']}></i>
                        </span>
                        <h3>{caracteristica['elnombre']}</h3>
                        <div className="caracteristica-desc" dangerouslySetInnerHTML={{ __html: limpiarHtml(caracteristica['ladesc']) }}></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

const Caracteristicas = ({ caracteristicas, config, variant }) => {

    return (
        caracteristicas.length > 0 ?
            <div className="mb-5 pt-4 pb-5">
                {variant === "carousel"
                    ? <CarouselCaracteristicas caracteristicas={caracteristicas} config={config} />
                    : <Container>
                        <ListaCaracteristicas
                            caracteristicas={caracteristicas}
                            config={config}
                        />
                    </Container>
                }
            </div>
            :
            <></>
    );
}

export default Caracteristicas;
